import { color } from '@upstox/upstox-ui';

export const header: CSSFunction = ({ cssProps, theme }) => ({
  borderBottom: cssProps.showBorder ? `1px solid ${color(theme, 'ui3')}` : 'none',
});
